/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Ionicons } from '@expo/vector-icons';
import { Text, TouchableOpacity, View } from 'react-native';
import { colors } from '../theme/public-api';
import { operationalFilterStyles as styles } from './operationalFilters.styles';

type Props = {
  caption: string;
  value: string;
  active?: boolean;
  dense?: boolean;
  onPress: () => void;
  accessibilityLabel?: string;
};

/** Picker denso (caption + valor) para toolbar PC en POS, Catálogo e Inventario. */
export function MasterFilterCompactPicker({
  caption,
  value,
  active = false,
  dense = false,
  onPress,
  accessibilityLabel,
}: Props) {
  return (
    <TouchableOpacity
      style={[
        styles.masterCompactPicker,
        dense && styles.masterCompactPickerDense,
        active && styles.masterCompactPickerActive,
      ]}
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel ?? `${caption}: ${value}. Abrir lista`}
    >
      <View style={styles.masterCompactPickerInner}>
        <Text style={styles.masterCompactPickerCaption}>{caption}</Text>
        <Text style={styles.masterCompactPickerValue} numberOfLines={1}>
          {value}
        </Text>
      </View>
      <Ionicons name="chevron-down" size={18} color={colors.textSecondary} />
    </TouchableOpacity>
  );
}
